import RemoveSupplyContext, {
  RemoveSupplyProvider,
} from "src/context/RemoveSupplyContext";
import { useRemoveSupplyEffect } from "./hooks/useRemoveSupplyEffect";
import React from "react";
import { Loadable } from "src/components/Loading";
import { Detail } from "src/templates";
import { AlertBannerSection } from "./AlertBannerSection";
import { SnackbarSection } from "./SnackbarSection";
import { ContentSection } from "./ContentSection";
import { SidebarSection } from "./SidebarSection";
import { RemoveSupplyDetailProps } from "./types";

export const RemoveSupplyDetail = ({
  "data-id": dataId = "removeSupplyDetail",
}: RemoveSupplyDetailProps) => {
  const { formValues, isLoading } = useRemoveSupplyEffect();
  const { premiseAddress } = React.useContext(RemoveSupplyContext);

  return (
    <Loadable isLoading={isLoading}>
      <Detail
        pageTitleSection={"Notification of proposal to remove supply"}
        addressSection={premiseAddress}
        sidebarSection={
          <SidebarSection
            showSupportingDocuments={!!formValues.networkFormNumber}
            showRemovalDetails={
              !!formValues.abolishmentDate || !!formValues.abolishmentForm?.[0]
            }
          />
        }
        alertBannerSection={<AlertBannerSection />}
        snackbarSection={<SnackbarSection />}
        data-id={dataId}
      >
        <ContentSection formValues={formValues} />
      </Detail>
    </Loadable>
  );
};

export const RemoveSupply: React.FC = () => {
  return (
    <RemoveSupplyProvider>
      <RemoveSupplyDetail />
    </RemoveSupplyProvider>
  );
};
